import { render, staticRenderFns } from "./TributeSlideshow.vue?vue&type=template&id=db946de6&scoped=true"
import script from "./TributeSlideshow.vue?vue&type=script&lang=js"
export * from "./TributeSlideshow.vue?vue&type=script&lang=js"
import style0 from "./TributeSlideshow.vue?vue&type=style&index=0&id=db946de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db946de6",
  null
  
)

export default component.exports